<script>
  import axios from "axios";
  import qs from "qs";
  import { onMount } from "svelte";
  import Button from "@smui/button";
  import Checkbox from "@smui/checkbox";
  import List, { Item } from "@smui/list";
  import Banner, { Label, Icon, CloseReason } from '@smui/banner';
  import Textfield from "@smui/textfield";
  import { Icon as CommonIcon } from "@smui/common";
  import Paper, { Title, Subtitle, Content } from "@smui/paper";
  import FormField from "@smui/form-field";
  import { Stretch } from "svelte-loading-spinners";
  import Chip, { Set, Text } from "@smui/chips";

  const axiosAPI = axios.create({
    baseURL: "https://api.podlodka.io/billingator",
//    baseURL: "http://localhost:8080",
    // baseURL: "https://stoplight.io/mocks/podlodka/billingator/9903012",
    // baseURL: "https://gentle-lowlands-77779.herokuapp.com",
  });

  // loading state
  let submitLoading = false;

  $: isSubmitButtonEnabled = !isFormInvalid && !submitLoading;
  $: isFormInvalid =
    checkedPlaylists.length == 0 ||
    !email ||
    !firstname ||
    !lastname ||
    !policyChecked;

  let promocode = "";
  let email = "";
  let firstname = "";
  let lastname = "";
  let playlists = [];
  let filteredPlaylists = [];
  let isUnderMaintenance;

  let filters = new Map([
    ['All_Playlists', '👑'],
    ["Thematic", "🤓 Тематические"],
    ["iOS", "iOS"],
    ["Android", "Android"],
    ["Frontend", "Frontend"],
    ["Backend", "Backend"],
    ["Go", "Go"],
    ["PHP", "PHP"],
    ["Java", "Java"],
    ["Python", "🐍 Python"],
    ["QA", "QA"],
    ["Softskills", "Softskills"],
    ["TL", "Teamlead"],
    ["Techlead", "Techlead"],
    ["Product", "Product"],
    ["Design", "Design"],
    ["HR", "HR"],
    ["Crossplatform", "Crossplatform"],
    ["Best", "Best"],
    ]);
  let filter = undefined;
  let preselectedPlaylistId = undefined;

  $: if (filter != undefined && playlists.length > 0) {
    applyFilters();
  }

  let initialPrice;
  let discountPrice;
  let currentDiscount;
  let nextDiscount;
  let policyChecked = false;
  $: if (checkedPlaylists) {
    fetchPrice();
  }

  let checkedPlaylists = [];
  let playlistArea;
  let filterParameter;
  let fetchPlaylistsPromise;

  onMount(async () => {
    playlistArea = document
      .getElementsByTagName("svelteapp")[0]
      .getAttribute("product_area");

    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.has("area")) {
      playlistArea = urlParams.get("area");
    }

    if (urlParams.has("filter")) {
      let filterId = urlParams.get("filter");
      filter = {name: filterId, value: filters.get(filterId)}
    }

    if (urlParams.has("playlist_id")) {
      preselectedPlaylistId = urlParams.get("playlist_id");
    }

    fetchPlaylistsPromise = fetchPlaylists();
  });

  async function checkMaintenanceStatus() {
    let result = await axiosAPI.get("/maintenance");
    return result.data["under_maintenance"];
  }

  async function fetchPlaylists() {
    isUnderMaintenance = await checkMaintenanceStatus();
    if (isUnderMaintenance) {
      return;
    }

    try {
      var params = {
        offer_ids: playlists.map((playlist) => playlist.main_offer.offer_id),
        promo: promocode,
      };
      if (playlistArea) {
        params.area = playlistArea;
      } else {
        params.product_type = "playlist";
      }

      let result = await axiosAPI.get("/playlists", {
        params: params,

        paramsSerializer: function (params) {
          return qs.stringify(params, { arrayFormat: "repeat" });
        },
      });
      playlists = result.data;
      playlists.sort(
        (a, b) => a.main_offer.product_season - b.main_offer.product_season
      );

      if (filterParameter) {
        playlists = playlists.filter((pl) =>
          pl.main_offer.offer_id.includes(filterParameter)
        );
        applyFilters();
      }
      preselectedPlaylist();

      trackEvent("playlistCheckout");
    } catch (error) {
      alert(error);
    }
  }

  async function fetchPrice() {
    if (checkedPlaylists.length == 0) {
      discountPrice = undefined;
      initialPrice = undefined;
      currentDiscount = undefined;
      nextDiscount = undefined;
      return;
    }

    try {
      const result = await axiosAPI.get("/price", {
        params: {
          offer_ids: checkedPlaylists.map(
            (playlist) => playlist.main_offer.offer_id
          ),
          promo: promocode,
        },
        paramsSerializer: function (params) {
          return qs.stringify(params, { arrayFormat: "repeat" });
        },
      });
      let json = await result;
      if (json.data.discount_price !== undefined) {
        discountPrice = json.data.discount_price;
        initialPrice = json.data.initial_price;
        currentDiscount = json.data.current_discount;
        nextDiscount = json.data.next_discount;
      } else if (json.data.Error) {
        alert(json.data.Error);
      }
    } catch (error) {
      alert(error);
    }
  }

  const preselectedPlaylist = () => {
    let preselectedPlaylist = playlists.find(
      (pl) => pl.main_offer.offer_id == preselectedPlaylistId
    );
    if (preselectedPlaylist) {
      checkedPlaylists.push(preselectedPlaylist);
      let index = playlists.indexOf(preselectedPlaylist);
      playlists.unshift(playlists.splice(index, 1)[0]);
    }
    preselectedPlaylistId = undefined;
  };

  const applyFilters = () => {
    filteredPlaylists = playlists.filter((pl) =>
      pl.main_offer.offer_id.includes(filter.name.toLowerCase())
    );

    if (filteredPlaylists.length == 0) {
      filteredPlaylists = playlists;
    }

    const params = new URLSearchParams(window.location.search);
    params.set("filter", filter.name);

    window.history.pushState(
      {},
      document.title,
      params.toString().length == 0
        ? window.location.pathname
        : window.location.pathname + "?" + params.toString()
    );
  };

  const submitForm = async () => {
    if (checkedPlaylists.length == 0) {
      alert("Выберите плейлисты");
      return;
    }

    if (!policyChecked) {
      alert(
        "Для продолжения необходимо принять условия лицензионного соглашения"
      );
      return;
    }

    trackEvent("playlistPurchase", discountPrice);

    try {
      submitLoading = true;
      const result = await axiosAPI.post("/buy", createPaymentFormData());
      submitLoading = false;

      if (result.data.confirmation_url) {
        window.location.assign(result.data.confirmation_url);
        return;
      } else if (result.data.confirmation_status == "free") {
        alert("Спасибо за покупку! ;)");
        return;
      } else if (result.data.Error) {
        alert(result.data.Error);
        return;
      } else {
        alert("Что-то пошло не так. Успешный ответ, но нет confirmation_url");
        return;
      }
    } catch (error) {
      submitLoading = false;
      alert(error);
    }
  };

  function createPaymentFormData() {
    var formData = {};

    formData["customer_email"] = email;
    formData["customer_name"] = firstname;
    formData["customer_surname"] = lastname;
    if (promocode) {
      formData["promo"] = promocode;
    }

    var orders = [];
    checkedPlaylists.forEach((element) => {
      var order = {
        first_name: firstname,
        last_name: lastname,
        email: email,
        offer_id: element.main_offer.offer_id,
      };
      orders.push(order);
    });
    formData["orders"] = orders;
    return formData;
  }

  function trackEvent(event, value) {
    if (typeof gtag !== "undefined") {
      var payload = {
        event_category: "payment_platform",
        event_label: "playlists",
        value: value,
      };

      gtag("event", event, payload);
    }

    if (typeof fbq !== "undefined") {
      var payload = {
        content_category: "payment_platform",
        content_name: "playlists",
      };

      if (value) {
        payload["value"] = value;
        payload["currency"] = "RUB";
      }

      fbq("trackCustom", event, payload);
    }
  }
</script>

<main>
  <div class="box">
    <div class="paper-container">
      <Paper elevation={1} class="paper-demo">
        <div class="title">
          <Title>YouTube-плейлисты</Title>
        </div>
        {#await fetchPlaylistsPromise}
          <div class="loader">
            <Stretch size="100" unit="px" />
          </div>
        {:then}
          {#if isUnderMaintenance}
            <p>Прямо сейчас мы шатаем форму на бою 😱</p>
          {:else if playlists}
            <Content>
              <Set chips={Array.from(filters, ([name, value]) => ({ name, value }))} let:chip choice bind:selected={filter}>
                <Chip {chip} touch>
                  <Text>{chip.value}</Text>
                </Chip>
              </Set>
              <List checkList>
                {#each filteredPlaylists as playlist (playlist.main_offer.offer_id)}
                  <Item style="height: fit-content; padding: 10px 0px;">
                    <Checkbox bind:group={checkedPlaylists} value={playlist} />
                    <p wrap>
                      {playlist.main_offer.product_name}
                    </p>
                  </Item>
                {/each}
              </List>
              {#await fetchPrice}
                <div class="loader">
                  <Stretch size="100" unit="px" />
                </div>
              {:then}
                {#if discountPrice == 0 || discountPrice == null}
                  <h3 style="margin: 0px 15px 0px">Бесплатно</h3>
                {:else}
                  <div class="cart-box">
                    <div>
                      <ul class="card-list">
                        {#each checkedPlaylists as playlist (playlist.main_offer.offer_id)}
                          <li class="card-list-item">
                            <p style="font-size: 15px; margin-bottom: 0px;">
                              {playlist.main_offer.product_name}
                            </p>
                            <p
                              style="font-size: 12px; color: #999; margin: 0px;"
                            >
                            {#if currentDiscount > 0 }
                              <s>{playlist.main_offer.discounted_price}₽</s>
                            {/if}
                              {playlist.main_offer.discounted_price *
                                (1 - currentDiscount)}₽
                            </p>
                          </li>
                        {/each}
                      </ul>
                      <hr />
                    </div>
                    <h3 style="margin: 0px 15px 0px">
                      {discountPrice}₽
                      {#if currentDiscount != 0}
                        <span
                          style="font-size: {14 +
                            ((currentDiscount * 100) / 5) * 1.5}px; color: #999"
                        >
                          <s>{initialPrice}₽</s>
                          (скидка {currentDiscount * 100}%)
                        </span><br />
                      {/if}
                    </h3>
                    {#if currentDiscount != nextDiscount}
                      <h3
                        style="font-size: 12px; color: #999; margin: 0px 15px 0px"
                      >
                        со следующего плейлиста скидка: {nextDiscount * 100}% 😏
                      </h3>
                    {/if}
                  </div>
                {/if}
              {/await}
            </Content>
          {/if}
        {:catch error}
          <p style="color: red">{error.message}</p>
          <p>
            Что-то пошло не так. Напишите в
            <a href="https://t.me/podlodkacrew_support">чат саппорта</a>
          </p>
        {/await}
      </Paper>
    </div>

    {#await fetchPlaylistsPromise then isUnderMaintenance}
      {#if !isUnderMaintenance}
        <div class="paper-container">
          <Paper elevation={1} class="paper-demo" style="background-color: #d3e2fd">
              <Content>
              <!--<Banner open mobileStacked>-->
              <div style="display: flex; justify-content: center;">
                <Icon class="material-icons" style="margin: 0 10px">favorite_border</Icon>
                <p style="font-size: 16px; margin: 0 10px;">А еще у нас есть <a href="?filter=All_Playlists&playlist_id=all_playlists">годовая подписка</a> на ВСЕ плейлисты в библиотеке!</p>
              </div>
              </Content>
          </Paper>
        </div>

        <div class="paper-container">
          <Paper elevation={1} class="paper-demo">
            <div class="title">
              <Title>Промокод</Title>
            </div>
            <Content>
              <div class="promocode-box">
                <div class="promocode_input">
                  <Textfield variant="outlined" bind:value={promocode} />
                </div>
                <Button
                  variant="unelevated"
                  on:click={fetchPrice}
                  disabled={!promocode}
                  class="fatButton"
                >
                  Применить
                </Button>
              </div>
            </Content>
          </Paper>
        </div>

        <div class="paper-container">
          <Paper elevation={1} class="paper-demo">
            <div class="title">
              <Title>Данные</Title>
              <Subtitle>Покупка придет на указанную почту</Subtitle>
            </div>
            <div class="personal_input">
              <Textfield
                style="width: 90%"
                variant="outlined"
                bind:value={lastname}
                label="Фамилия"
                input$autocomplete="family_name"
                required
              />
            </div>
            <div class="personal_input">
              <Textfield
                id="input-firstname"
                style="width: 90%"
                variant="outlined"
                bind:value={firstname}
                input$autocomplete="first_name"
                label="Имя"
                required
              />
            </div>
            <div class="personal_input">
              <Textfield
                style="width: 90%"
                variant="outlined"
                bind:value={email}
                input$autocomplete="email"
                label=""
                type="email"
              >
                <span slot="label"
                  ><CommonIcon
                    class="material-icons"
                    style="font-size: 1em; line-height: normal; vertical-align: middle;"
                  >
                    email
                  </CommonIcon>
                  Email</span
                >
              </Textfield>
            </div>
            <div class="license">
              <FormField required>
                <Checkbox bind:checked={policyChecked} />
                <span slot="label"
                  >Я подтверждаю свое согласие с условиями
                  <a href="https://podlodka.io/crew-legal"
                    >Пользовательского соглашения</a
                  >
                  и
                  <a href="https://podlodka.io/data-processing"
                    >Обработки персональных данных</a
                  ></span
                >
              </FormField>
            </div>
            <Button
              style="margin: 0px 10px;"
              class="submit"
              variant="unelevated"
              on:click={submitForm}
              disabled={!isSubmitButtonEnabled}
            >
              Беру!
            </Button>
            {#if submitLoading}
              <div style="margin: 0px 10px;">
                <Stretch size="50" unit="px" />
              </div>
            {/if}
          </Paper>
        </div>
      {/if}
    {/await}
  </div>
</main>

<style>
  main {
    background-color: #f8f8f8;
  }
  .title {
    margin: 0px 10px;
  }
  .paper-container {
    padding: 9px 18px;
    max-width: 45em;
    margin-left: auto;
    margin-right: auto;
  }
  .promocode-box {
    margin: 12px 10px;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
  }

  .loader {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 256px;
  }

  .box {
    padding: 100px 0;
    max-height: 80vh;
    overflow: auto;
  }

  .promocode_input {
    margin-right: 10px;
  }

  .personal_input {
    width: 55%;
    margin: 10px;
  }

  .license {
    margin-bottom: 10px;
  }

  .cart-box {
    border-width: 1px;
    border-radius: 8px;
    border-style: solid;
    border-color: rgb(158, 158, 158);
    margin: 20px 10px;
    padding: 4px;
  }

  .card-list {
    margin-top: 0px;
    padding-inline-start: 15px;
    padding-inline-end: 15px;
  }

  .card-list-item {
    position: relative;
    overflow: auto;
  }

  * :global(.fatButton) {
    height: 50px;
    margin-bottom: 0px;
  }

  @media (max-width: 500px) {
    .promocode_input {
      width: 100%;
      margin-bottom: 10px;
    }
    .personal_input {
      width: 100%;
    }
  }
</style>
